/**
 * Enum representing different size options for UI components, like buttons or links.
 */
export enum Size {
  None = '',
  Large = 'lg',
  Medium = 'md',
  Small = 'sm'
}
